import React, { useState } from "react";
import { Box, Checkbox, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { borderStyle, cardStyle, contentBoxStyle } from "../shared/Theme";
import Sidebar from "../elements/Sidebar";
import Header from "../elements/Header";
import { blueGradientBackground, pink } from "../shared/colours";
import { useRef } from "react";
import { ArrowCircleUpSharp, Circle, HelpOutline } from "@mui/icons-material";
import SubmitModal from "../elements/Admin/SubmitModal";
import formService from "../services/formService";
import alertService from "../services/alertService";

const PenTesting = () => {

	let [ showSubmitModal, setShowSubmitModal ] = useState(false);
	let [ sentSuccess, setSentSuccess ] = useState(false);
	
	const mobileAppJourneysHelp = `
		A user journey is set of processes that perform a specific task. The user journeys 
		of your app define what it actually does for the user. For example, an airline 
		application might have the following journeys: Search for flights, Book a ticket, 
		Change a reservation, Check-in. Please provide the number of distinct user journeys 
		your application provides.
	`;
	const cloudAssessmentHelp = `
		We will need to login to this provider to view the configuration and conduct 
		our assessment.
	`;
	
	const externalInfraTesting = useRef(null);
	const externalInfraIPs = useRef(null);
	const internalInfraTesting = useRef(null);
	const internalInfraIPs = useRef(null);
	const internalInfraRemoteYes = useRef(null);
	const internalInfraRemoteNo = useRef(null);
	const webAppTesting = useRef(null);
	const webAppUserRoles = useRef(null);
	const webAppUserJourneys = useRef(null);
	const internalAppTesting = useRef(null);
	const internalAppUserRoles = useRef(null);
	const internalAppUserJourneys = useRef(null);
	const pciSegTesting = useRef(null);
	const pciSegCDEs = useRef(null);
	const pciSegRemoteYes = useRef(null);
	const pciSegRemoteNo = useRef(null);
	const apiAssessment = useRef(null);
	const apiAssessmentRoles = useRef(null);
	const apiAssessmentFunctions = useRef(null);
	const cloudAssessment = useRef(null);
	const cloudAssessmentAWS = useRef(null);
	const cloudAssessmentAzure = useRef(null);
	const cloudAssessmentGoogle = useRef(null);
	const cloudAssessmentOther = useRef(null);
	const mobileTesting = useRef(null);
	const mobileTestingIOS= useRef(null);
	const mobileTestingAndroid = useRef(null);
	const mobileTestingJourneys = useRef(null);
	
	const handleSubmitClick = async () => {
		setSentSuccess(false);
		setShowSubmitModal(true);
		await formService.penTesting({
			externalInfraTesting: externalInfraTesting.current.checked,
			externalInfraIPs: externalInfraIPs.current.value,
			internalInfraTesting: internalInfraTesting.current.checked,
			internalInfraIPs: internalInfraIPs.current.value,
			internalInfraRemoteYes: internalInfraRemoteYes.current.checked,
			internalInfraRemoteNo: internalInfraRemoteNo.current.checked,
			webAppTesting: webAppTesting.current.checked,
			webAppUserRoles: webAppUserRoles.current.value,
			webAppUserJourneys: webAppUserJourneys.current.value,
			internalAppTesting: internalAppTesting.current.checked,
			internalAppUserRoles: internalAppUserRoles.current.value,
			internalAppUserJourneys: internalAppUserJourneys.current.value,
			pciSegTesting: pciSegTesting.current.checked,
			pciSegCDEs: pciSegCDEs.current.value,
			pciSegRemoteYes: pciSegRemoteYes.current.checked,
			pciSegRemoteNo: pciSegRemoteNo.current.checked,
			apiAssessment: apiAssessment.current.checked,
			apiAssessmentRoles: apiAssessmentRoles.current.value,
			apiAssessmentFunctions: apiAssessmentFunctions.current.value,
			cloudAssessment: cloudAssessment.current.checked,
			cloudAssessmentAWS: cloudAssessmentAWS.current.checked,
			cloudAssessmentAzure: cloudAssessmentAzure.current.checked,
			cloudAssessmentGoogle: cloudAssessmentGoogle.current.checked,
			cloudAssessmentOther: cloudAssessmentOther.current.checked,
			mobileTesting: mobileTesting.current.checked,
			mobileTestingIOS: mobileTestingIOS.current.checked,
			mobileTestingAndroid: mobileTestingAndroid.current.checked,
			mobileTestingJourneys: mobileTestingJourneys.current.value
		});
		setSentSuccess(true);
		setTimeout(() => {
			setShowSubmitModal(false);
		}, 1500);
	};
	
	const handleSubmitModalClose = () => {
		setSentSuccess(false);
		setShowSubmitModal(false);
	};
	
	const handleExternalInfraClick = () => {
		document.getElementById("externalInfraMore").style.display =
			(externalInfraTesting.current.checked)? "block" : "none";
	};
	
	const handleInternalInfraClick = () => {
		document.getElementById("internalInfraMore").style.display =
			(internalInfraTesting.current.checked)? "block" : "none";
	};
	
	const handleWebAppClick = () => {
		document.getElementById("webAppMore").style.display =
			(webAppTesting.current.checked)? "block" : "none";
	};
	
	const handleInternalAppClick = () => {
		document.getElementById("internalAppMore").style.display =
			(internalAppTesting.current.checked)? "block" : "none";
	};
	
	const handlePCISegClick = () => {
		document.getElementById("pciSegMore").style.display =
			(pciSegTesting.current.checked)? "block" : "none";
	};
	
	const handleAPIAssessmentClick = () => {
		document.getElementById("apiAssessmentMore").style.display =
			(apiAssessment.current.checked)? "block" : "none";
	};
	
	const handleCloudAssessmentClick = () => {
		document.getElementById("cloudAssessmentMore").style.display =
			(cloudAssessment.current.checked)? "block" : "none";
	};
	
	const handleMobileTestingClick = () => {
		document.getElementById("mobileTestingMore").style.display =
			(mobileTesting.current.checked)? "block" : "none";
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar/>
			{/* <AccountGuard requiredService="all"/> */}
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Header pageTitle="Penetration Testing"/>
				<Box sx={contentBoxStyle}>
					<Stack
						sx={{ ...cardStyle, width: "80%", margin: "auto", paddingBottom: "1em", padding: "1em" }}
						justifyContent="center"
						alignItems="center"
						spacing="2em"
					>
						<Typography
							variant="h5"
							sx={{ width: "100%", textAlign: "center", fontWeight: "bold", marginTop: "1em" }}
						>
							Penetration Test - Scoping
						</Typography>
						<Typography
							sx={{
								width: "100%",
								textAlign: "center",
								margin: "2em 0 3em 0",
								fontSize: "0.8em",
								borderLeft: "2px solid",
								borderRight: "2px solid",
								...borderStyle
							}}
						>
							In order to accurately scope your Penetration Test, we need you to provide some key
							information.<br/><br/>
							Please provide as much detail and accuracy as you can, as this will help to ensure the
							test is sufficient and we cover all the areas required.<br/><br/>
							Once you complete the fields below, we will collate that information and send you a quote
							for the Testing, which will include an estimated duration of Testing and detail any access
							requirements for our CREST Approved Testers.<br/><br/>
							Once accepted, we will contact you to schedule the testing and when the Test has been
							completed you will be able to access the Report right here in your
							<span style={{ fontWeight: "bold" }}> Cymplify</span> account.
						</Typography>
						<Stack direction="column" alignItems="flexStart" sx={{ width: "70%" }}>
							<Stack direction="row" spacing="1em" SX={{ border: "1px solid text.border" }}>
								<Checkbox
									inputRef={externalInfraTesting}
									sx={{
										border: `2px solid ${pink}`,
										borderRadius: "0.5em",
										width: "2.5em",
										height: "2.5em",
										'&.Mui-checked': {
											color: pink
										}
									}}
									icon={<React.Fragment/>}
									onClick={handleExternalInfraClick}
									/>
								<Typography sx={{ paddingTop: "0.5em" }}>External Infrastructure Testing</Typography>
							</Stack>
							<Stack 
								direction="column"
								id="externalInfraMore"
								spacing="1em"
								sx={{ display: "none", margin: "1em", paddingLeft: "2em"}}
							>
								<Stack direction="row" spacing="1em">
									<Circle sx={{ marginTop: "2.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										How many external IP's will be live during testing?
									</Typography>
									<TextField
										inputRef={externalInfraIPs}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											}
										}}
									/>
								</Stack>
							</Stack>
						</Stack>
						<Stack direction="column" alignItems="flexStart" sx={{ width: "70%" }}>
							<Stack direction="row" spacing="1em" SX={{ border: "1px solid text.border" }}>
								<Checkbox
									inputRef={internalInfraTesting}
									sx={{
										border: `2px solid ${pink}`,
										borderRadius: "0.5em",
										width: "2.5em",
										height: "2.5em",
										'&.Mui-checked': {
											color: pink
										}
									}}
									icon={<React.Fragment/>}
									onClick={handleInternalInfraClick}
								/>
								<Typography sx={{ paddingTop: "0.5em" }}>Internal Infrastructure Testing</Typography>
							</Stack>
							<Stack 
								direction="column"
								id="internalInfraMore"
								spacing="1em"
								sx={{ display: "none", margin: "1em", paddingLeft: "2em"}}
							>
								<Stack direction="row" spacing="1em">
									<Typography sx={{ paddingTop: "0.5em", fontSize: "0.8em" }}>
										We carry out the majority of our internal infrastructure tests remotely via a 
										virtual device which you will deploy to your network. This is secure and is also 
										cheaper for you, as it reduces the test duration and travel expenses.
									</Typography>
								</Stack>
								<Stack direction="row" spacing="1em">
									<Circle sx={{ marginTop: "2.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										How many IP's will be live during testing?
									</Typography>
									<TextField
										inputRef={internalInfraIPs}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											}
										}}
									/>
								</Stack>
								<Stack direction="row" spacing="1em">
									<Circle sx={{ marginTop: "2.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										Can we perform this test remotely?
									</Typography>
									<Typography sx={{ paddingTop: "0.5em" }}>Yes</Typography>
									<Checkbox
										inputRef={internalInfraRemoteYes}
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "2.5em",
											height: "2.5em",
											'&.Mui-checked': {
												color: pink
											}
										}}
										icon={<React.Fragment/>}
									/>
									<Typography sx={{ paddingTop: "0.5em" }}>No</Typography>
									<Checkbox
										inputRef={internalInfraRemoteNo}
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "2.5em",
											height: "2.5em",
											'&.Mui-checked': {
												color: pink
											}
										}}
										icon={<React.Fragment/>}
									/>
								</Stack>
							</Stack>
						</Stack>
						<Stack direction="column" alignItems="flexStart" sx={{ width: "70%" }}>
							<Stack direction="row" spacing="1em" SX={{ border: "1px solid text.border" }}>
								<Checkbox
									inputRef={webAppTesting}
									sx={{
										border: `2px solid ${pink}`,
										borderRadius: "0.5em",
										width: "2.5em",
										height: "2.5em",
										'&.Mui-checked': {
											color: pink
										}
									}}
									icon={<React.Fragment/>}
									onClick={handleWebAppClick}
									/>
								<Typography sx={{ paddingTop: "0.5em" }}>Web Application</Typography>
							</Stack>
							<Stack 
								direction="column"
								id="webAppMore"
								spacing="1em"
								sx={{ display: "none", margin: "1em", paddingLeft: "2em"}}
							>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "-2.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										How many user roles does this web application have?<br/>
										Please enter 0 if unauthenticated testing only is required.
									</Typography>
									<TextField
										inputRef={webAppUserRoles}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											},
											maxHeight: "2.6em"
										}}
									/>
								</Stack>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "-2.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										Roughly how many user journeys does this web application have?<br/>
										(excluding login)
									</Typography>
									<TextField
										inputRef={webAppUserJourneys}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											},
											maxHeight: "2.6em"
										}}
									/>
								</Stack>
							</Stack>
						</Stack>
						<Stack direction="column" alignItems="flexStart" sx={{ width: "70%" }}>
							<Stack direction="row" spacing="1em" SX={{ border: "1px solid text.border" }}>
								<Checkbox
									inputRef={internalAppTesting}
									sx={{
										border: `2px solid ${pink}`,
										borderRadius: "0.5em",
										width: "2.5em",
										height: "2.5em",
										'&.Mui-checked': {
											color: pink
										}
									}}
									icon={<React.Fragment/>}
									onClick={handleInternalAppClick}
									/>
								<Typography sx={{ paddingTop: "0.5em" }}>Internal Web Application</Typography>
							</Stack>
							<Stack 
								direction="column"
								id="internalAppMore"
								spacing="1em"
								sx={{ display: "none", margin: "1em", paddingLeft: "2em"}}
							>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "-2.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										How many user roles does this web application have?<br/>
										Please enter 0 if unauthenticated testing only is required.
									</Typography>
									<TextField
										inputRef={internalAppUserRoles}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											},
											maxHeight: "2.6em"
										}}
									/>
								</Stack>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "-2.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										Roughly how many user journeys does this web application have?<br/>
										(excluding login)
									</Typography>
									<TextField
										inputRef={internalAppUserJourneys}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											},
											maxHeight: "2.6em"
										}}
									/>
								</Stack>
							</Stack>
						</Stack>
						<Stack direction="column" alignItems="flexStart" sx={{ width: "70%" }}>
							<Stack direction="row" spacing="1em" SX={{ border: "1px solid text.border" }}>
								<Checkbox
									inputRef={pciSegTesting}
									sx={{
										border: `2px solid ${pink}`,
										borderRadius: "0.5em",
										width: "2.5em",
										height: "2.5em",
										'&.Mui-checked': {
											color: pink
										}
									}}
									icon={<React.Fragment/>}
									onClick={handlePCISegClick}
									/>
								<Typography sx={{ paddingTop: "0.5em" }}>PCI Segmentation</Typography>
							</Stack>
							<Stack 
								direction="column"
								id="pciSegMore"
								spacing="1em"
								sx={{ display: "none", margin: "1em", paddingLeft: "2em"}}
							>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "1.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										How many CDEs (Cardholder Data Environments) does your organisation have?
									</Typography>
									<TextField
										inputRef={pciSegCDEs}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											},
											maxHeight: "2.6em"
										}}
									/>
								</Stack>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "1.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										Can we perform this test remotely?
									</Typography>
									<Typography sx={{ paddingTop: "0.5em" }}>Yes</Typography>
									<Checkbox
										inputRef={pciSegRemoteYes}
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "2.5em",
											height: "2.5em",
											'&.Mui-checked': {
												color: pink
											}
										}}
										icon={<React.Fragment/>}
									/>
									<Typography sx={{ paddingTop: "0.5em" }}>No</Typography>
									<Checkbox
										inputRef={pciSegRemoteNo}
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "2.5em",
											height: "2.5em",
											'&.Mui-checked': {
												color: pink
											}
										}}
										icon={<React.Fragment/>}
									/>
								</Stack>
							</Stack>
						</Stack>
						<Stack direction="column" alignItems="flexStart" sx={{ width: "70%" }}>
							<Stack direction="row" spacing="1em" SX={{ border: "1px solid text.border" }}>
								<Checkbox
									inputRef={apiAssessment}
									sx={{
										border: `2px solid ${pink}`,
										borderRadius: "0.5em",
										width: "2.5em",
										height: "2.5em",
										'&.Mui-checked': {
											color: pink
										}
									}}
									icon={<React.Fragment/>}
									onClick={handleAPIAssessmentClick}
									/>
								<Typography sx={{ paddingTop: "0.5em" }}>API Assessment</Typography>
							</Stack>
							<Stack 
								direction="column"
								id="apiAssessmentMore"
								spacing="1em"
								sx={{ display: "none", margin: "1em", paddingLeft: "2em"}}
							>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "-5em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										How many user roles does this API have?<br/>
										Please enter 0 if unauthenticated testing<br/>
										only is required.
									</Typography>
									<TextField
										inputRef={apiAssessmentRoles}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											},
											maxHeight: "2.6em"
										}}
									/>
								</Stack>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "1.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										Roughly how many functions does this API have?
									</Typography>
									<TextField
										inputRef={apiAssessmentFunctions}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											},
											maxHeight: "2.6em"
										}}
									/>
								</Stack>
							</Stack>
						</Stack>
						<Stack direction="column" alignItems="flexStart" sx={{ width: "70%" }}>
							<Stack direction="row" spacing="1em" SX={{ border: "1px solid text.border" }}>
								<Checkbox
									inputRef={cloudAssessment}
									sx={{
										border: `2px solid ${pink}`,
										borderRadius: "0.5em",
										width: "2.5em",
										height: "2.5em",
										'&.Mui-checked': {
											color: pink
										}
									}}
									icon={<React.Fragment/>}
									onClick={handleCloudAssessmentClick}
									/>
								<Typography sx={{ paddingTop: "0.5em" }}>Cloud Assessment</Typography>
							</Stack>
							<Stack 
								direction="column"
								id="cloudAssessmentMore"
								spacing="1em"
								sx={{ display: "none", margin: "1em", paddingLeft: "2em"}}
							>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "1.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										Which cloud service provider do you use?
										<Tooltip title={cloudAssessmentHelp}>
											<HelpOutline sx={{ paddingTop: "0.2em" }} onClick={() => {
												alertService.show(cloudAssessmentHelp);
											}}/>
										</Tooltip>
									</Typography>
								</Stack>
								<Stack direction="column" spacing="1em" alignItems="flex-start">
									<Stack direction="row" spacing="1em">
										<Checkbox
											inputRef={cloudAssessmentAWS}
											sx={{
												border: `2px solid ${pink}`,
												borderRadius: "0.5em",
												width: "2.5em",
												height: "2.5em",
												'&.Mui-checked': {
													color: pink
												}
											}}
											icon={<React.Fragment/>}
										/>
										<Typography sx={{ paddingTop: "0.5em" }}>AWS</Typography>
									</Stack>
									<Stack direction="row" spacing="1em">
										<Checkbox
											inputRef={cloudAssessmentAzure}
											sx={{
												border: `2px solid ${pink}`,
												borderRadius: "0.5em",
												width: "2.5em",
												height: "2.5em",
												'&.Mui-checked': {
													color: pink
												}
											}}
											icon={<React.Fragment/>}
										/>
										<Typography sx={{ paddingTop: "0.5em" }}>Azure</Typography>
									</Stack>
									<Stack direction="row" spacing="1em">
										<Checkbox
											inputRef={cloudAssessmentGoogle}
											sx={{
												border: `2px solid ${pink}`,
												borderRadius: "0.5em",
												width: "2.5em",
												height: "2.5em",
												'&.Mui-checked': {
													color: pink
												}
											}}
											icon={<React.Fragment/>}
										/>
										<Typography sx={{ paddingTop: "0.5em" }}>Google Cloud GCP</Typography>
									</Stack>
									<Stack direction="row" spacing="1em">
										<Checkbox
											inputRef={cloudAssessmentOther}
											sx={{
												border: `2px solid ${pink}`,
												borderRadius: "0.5em",
												width: "2.5em",
												height: "2.5em",
												'&.Mui-checked': {
													color: pink
												}
											}}
											icon={<React.Fragment/>}
										/>
										<Typography sx={{ paddingTop: "0.5em" }}>Other</Typography>
									</Stack>
								</Stack>
							</Stack>
						</Stack>
						<Stack direction="column" alignItems="flexStart" sx={{ width: "70%" }}>
							<Stack direction="row" spacing="1em" SX={{ border: "1px solid text.border" }}>
								<Checkbox
									inputRef={mobileTesting}
									sx={{
										border: `2px solid ${pink}`,
										borderRadius: "0.5em",
										width: "2.5em",
										height: "2.5em",
										'&.Mui-checked': {
											color: pink
										}
									}}
									icon={<React.Fragment/>}
									onClick={handleMobileTestingClick}
									/>
								<Typography sx={{ paddingTop: "0.5em" }}>Mobile Application Testing</Typography>
							</Stack>
							<Stack 
								direction="column"
								id="mobileTestingMore"
								spacing="1em"
								sx={{ display: "none", margin: "1em", paddingLeft: "2em"}}
							>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "1.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										Which platform do you require testing?
									</Typography>
								</Stack>
								<Stack direction="column" spacing="1em" alignItems="flex-start">
									<Stack direction="row" spacing="1em">
										<Checkbox
											inputRef={mobileTestingIOS}
											sx={{
												border: `2px solid ${pink}`,
												borderRadius: "0.5em",
												width: "2.5em",
												height: "2.5em",
												'&.Mui-checked': {
													color: pink
												}
											}}
											icon={<React.Fragment/>}
										/>
										<Typography sx={{ paddingTop: "0.5em" }}>iOS</Typography>
									</Stack>
									<Stack direction="row" spacing="1em">
										<Checkbox
											inputRef={mobileTestingAndroid}
											sx={{
												border: `2px solid ${pink}`,
												borderRadius: "0.5em",
												width: "2.5em",
												height: "2.5em",
												'&.Mui-checked': {
													color: pink
												}
											}}
											icon={<React.Fragment/>}
										/>
										<Typography sx={{ paddingTop: "0.5em" }}>Android</Typography>
									</Stack>
								</Stack>
								<Stack direction="row" spacing="1em" alignItems="center">
									<Circle sx={{ marginTop: "-2.2em", fontSize: "0.5em" }}/>
									<Typography sx={{ paddingTop: "0.5em" }}>
										Roughly how many user journeys does this mobile application have?<br/>
										(excluding login)
										<Tooltip title={mobileAppJourneysHelp}>
											<HelpOutline sx={{ paddingTop: "0.2em" }} onClick={() => {
												alertService.show(mobileAppJourneysHelp);
											}}/>
										</Tooltip>
									</Typography>
									<TextField
										inputRef={mobileTestingJourneys}
										size="small"
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "5em",
											'& .MuiOutlinedInput-root.Mui-focused': {
												"& > fieldset": {
													border: "0"
												}
											},
											'&:hover fieldset': {
												border: "0"
											},
											maxHeight: "2.6em"
										}}
									/>
								</Stack>
							</Stack>
						</Stack>
						<Stack direction="column" alignItems="flex-end" sx={{ width: "70%" }}>
							<Stack
								direction="row"
								sx={{
									width: "18em",
									height: "4em",
									marginTop: "2em",
									borderRadius: "2.5em",
									background: blueGradientBackground,
									"&:hover": {
										cursor: "pointer"
									}
								}}
								alignItems="center"
								justifyContent="center"
								spacing={1}
								onClick={handleSubmitClick}
							>
								<Typography
									sx={{ fontWeight: "bold", color: "#ffffff", paddingLeft: "0.5em" }}
								>
									Set Up Penetration Testing
								</Typography>
								<ArrowCircleUpSharp
									sx={{
										width: "2.5em",
										height: "2.5em",
										transform: "rotate(90deg)",
										color: "#ffffff"
									}}
								/>
							</Stack>
						</Stack>
					</Stack>
					<SubmitModal
						open={showSubmitModal}
						sentSuccess={sentSuccess}
						onClose={handleSubmitModalClose}
					/>
				</Box>
			</Box>
		</Box>
	);
}

export default PenTesting;
